async function asyncNoop() { }

export { asyncNoop };
